import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface WorkPlaceState {
  id: any;
  companyId: any;
  name: any;
  country: any;
  locality: any;
  address: any;
  details: any;
  timetable: any;
  company: any;
  contactPersons: any[];
  agents: any[];
  workPlaceItems: any[];
  props: {
    [key: string]: any;
  };
}

const initialState: WorkPlaceState = {
  id: '',
  companyId: '',
  name: '',
  country: '',
  locality: '',
  address: '',
  details: '',
  timetable: '',
  company: {},
  contactPersons: [],
  agents: [],
  workPlaceItems: [],
  props: { isModalVisible: false, refresh: false, searchTerm: '', skip: 1, take: 10, totalItems: 0 },
};

const workPlaceSlice = createSlice({
  name: 'workPlace',
  initialState,
  reducers: {
    setWorkPlace: (state, action: PayloadAction<Partial<WorkPlaceState>>) => {
      return { ...state, ...action.payload };
    },

    updateField: (state: WorkPlaceState, action: PayloadAction<{ field: any; value: any }>) => {
      const { field, value } = action.payload;
      (state as any)[field] = value;
    },

    /* Contact Persons */

    addContactPersons: (state, action: PayloadAction<any>) => {
      state.contactPersons.push(action.payload);
    },

    updateContactPersons: (state, action: PayloadAction<{ index: number; updates: any }>) => {
      const { index, updates } = action.payload;
      if (state.contactPersons[index]) {
        state.contactPersons[index] = {
          ...state.contactPersons[index],
          ...updates,
        };
      }
    },

    removeContactPersons: (state, action: PayloadAction<number>) => {
      const index = action.payload;
      if (index >= 0 && index < state.contactPersons.length) {
        state.contactPersons.splice(index, 1);
      }
    },

    /* Agents */

    addAgents: (state, action: PayloadAction<any>) => {
      state.agents.push(action.payload);
    },

    updateAgents: (state, action: PayloadAction<{ index: number; updates: any }>) => {
      const { index, updates } = action.payload;
      if (state.agents[index]) {
        state.agents[index] = {
          ...state.agents[index],
          ...updates,
        };
      }
    },

    removeAgents: (state, action: PayloadAction<number>) => {
      const index = action.payload;
      if (index >= 0 && index < state.agents.length) {
        state.agents.splice(index, 1);
      }
    },

    /* Work Place Items */

    addWorkPlaceItems: (state, action: PayloadAction<any>) => {
      state.workPlaceItems.push(action.payload);
    },

    updateWorkPlaceItems: (state, action: PayloadAction<{ index: number; updates: any }>) => {
      const { index, updates } = action.payload;
      if (index >= 0 && index < state.workPlaceItems.length) {
        // Merge updates with the existing item
        state.workPlaceItems[index] = {
          ...state.workPlaceItems[index],
          ...updates,
        };
      }
    },

    removeWorkPlaceItems: (state, action: PayloadAction<number>) => {
      const index = action.payload;
      if (index >= 0 && index < state.workPlaceItems.length) {
        state.workPlaceItems.splice(index, 1);
      }
    },

    updateProps: (state, action: PayloadAction<{ field: string; value: any }>) => {
      const { field, value } = action.payload;
      state.props = {
        ...state.props,
        [field]: value,
      };
    },
  },
});

export const {
  setWorkPlace,
  updateField,
  addContactPersons,
  updateContactPersons,
  removeContactPersons,
  addAgents,
  updateAgents,
  removeAgents,
  addWorkPlaceItems,
  updateWorkPlaceItems,
  removeWorkPlaceItems,
  updateProps,
} = workPlaceSlice.actions;

export default workPlaceSlice.reducer;
